import { CloseOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin, Tag } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  apiSubmit: () => void;
}

export default function HourlyRatesHistory({ onClose }: PropsType) {
  return (
    <Spin indicator={antIcon} size="large" spinning={false}>
      <div className="modalWrapper edit_lhr">
        <div className="modal_header">
          <div className="title">
            <h3> Hourly rates for estimates history </h3>
            <div className="serviceLineTag"></div>
          </div>
          <Button
            type="text"
            onClick={onClose}
            className="close-btn"
            icon={<CloseOutlined />}
          />
        </div>

        <div className="modal_content">
          <div className="serviceLineTag">
            Service line:
            <span>
              <Tag className="defaultTag light_green_tag">
                Landscape maintenance
              </Tag>
            </span>
          </div>

          {/* <h4
            style={{
              height: "100px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              color: "red",
            }}
          >
            Uzair bhai, drop a table here—before the content files a complaint!
          </h4> */}
        </div>
      </div>
    </Spin>
  );
}
